import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormGroupDirective, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { CustomPhonePipe } from 'src/app/shared/pipes/custom-data-filters.pipe';
import { CmnFunctionService } from 'src/app/shared/services/cmn-function.service';
import { ApiHandlerService } from '../../shared/services/api-handler.service';
import { ToasterService } from '../../shared/services/toaster.service';
import { API } from "src/app/shared/services/endpoints";
const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  public todayDate = new Date();
  contactForm: FormGroup;
  public isLoadingData: boolean = false;
  public submitted: boolean = false;
  public addedQuery: boolean = false;
  public inquryTypes: any;
  public socialLinks: any;

  @ViewChild(FormGroupDirective) contactFormGroupDirective: FormGroupDirective;

  constructor(
    public formBuilder: FormBuilder,
    public _service: ApiHandlerService,
    public cmnfunction: CmnFunctionService,
    public customPhone: CustomPhonePipe,

    public toaster: ToasterService) { }

  ngOnInit(): void {
    // To get Inquiry Types
    this.getInquiryTypes();
    this.getData()
    //below we initialize the validations...
    this.contactForm = this.formBuilder.group({
      name: ['', [Validators.required, this.noWhitespaceValidator()]], // Added whitespace validator
      email: ['', [
        Validators.required,
        Validators.email,
        Validators.pattern(EMAIL_REGEX) // Added strict pattern validator
      ]], mobileNumber: ['', Validators.required],
      type: ['', Validators.required],
      message: ['', [Validators.required, this.noWhitespaceValidator()]], // Added whitespace validator
    })
  }

  noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value && typeof control.value === 'string' && control.value.trim().length === 0) {
        return { 'whitespace': true };
      }
      return null;
    };
  }

  // convenience getter for easy access to form fields
  get f() { return this.contactForm.controls; }

  submitContact(formDirective) {
    this.submitted = true;
    if (this.contactForm.invalid) return;
    this.isLoadingData = true;

    //pass data to API here..
    const apiParam = {
      name: this.contactForm.value.name,
      email: this.contactForm.value.email,
      phoneNo: this.customPhone.transform(this.contactForm.value.mobileNumber, ''),
      type: this.contactForm.value.type,
      message: this.contactForm.value.message
    }

    this._service.apiPost(this._service.marketingBaseUrl + 'add-query', apiParam).subscribe({
      next: result => {
        if (result['status']) {
          this.isLoadingData = false;
          this.addedQuery = true;
          //reset data...
          this.submitted = false;
          this.contactForm.reset();
          this.contactForm.controls['type'].setValue('');
          this.toaster.Success(result.message);
        } else {
          this.addedQuery = false;
          this.toaster.Error(result.message);
        }
      }, error: err => {
        this.isLoadingData = false;
        this.toaster.Error(err);
      }
    });
  }


  getInquiryTypes() {
    this._service.apiGet(this._service.marketingBaseUrl + 'get-types').subscribe({
      next: result => {
        if (result.status) {
          this.inquryTypes = result.data.types;
        }
      }, error: err => {
        //  this.toaster.Error(err.mesage);
      }
    });
  }


  getData() {
    var apiData = {
      page: "home",
    };
    this._service
      .apiPost(API.CMS_ENDPOINTS.GET_PAGE, apiData)
      .subscribe((resp) => {
        this.socialLinks = resp.data.footer;
        // console.log('socialLinks :>> ', this.socialLinks);
      });
  }
}
